import { __initialize } from "./_core/core"; 
import { GAME_NAME } from './_game/config/Game';

document.title = GAME_NAME;

__initialize(); 